<template>
    <div class="row mb-4 p-1">
        <div class="col-lg-6">
            <div v-if="intervenant.contact">
                <contact :id="intervenant.contact" :new="newContact" v-on:update-contact="updateContact"></contact>
            </div>
            <div v-else class="text-center">
                <div class="btn border" v-on:click="addContact">Ajouter un contact</div>
                <div class="btn border disabled">Rechercher un contact (à venir)</div>
            </div>
        </div>
        <div class="col-lg-6" v-if="errors.length === 0">
            <div class="mt-1 mb-2">
                <b-form-radio-group v-model="intervenant.aInviter">
                    <b-form-radio value="true">invité</b-form-radio>
                    <b-form-radio value="false">contact booking</b-form-radio>
                </b-form-radio-group>
            </div>
            <div class="mt-2 mb-2">
                <b-form-radio-group v-model="intervenant.type">
                    <b-form-radio value="au studio">au studio</b-form-radio>
                    <b-form-radio value="au télephone">au téléphone</b-form-radio>
                </b-form-radio-group>
            </div>
            <div class="mt-2 mb-2">
                <b-form-checkbox class="mb-2 mt-2" v-model="intervenant.envoiEmail" @change="lockChangePartage">
                    Partager le podcast par email
                </b-form-checkbox>
            </div>
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <b-form-radio-group v-model="intervenant.statut">
                    <label class="btn btn-secondary">
                        <b-form-radio value="Contact établit">Contact établit</b-form-radio>
                    </label>
                    <label class="btn btn-secondary">
                        <b-form-radio value="Invité validé">Invité validé</b-form-radio>
                    </label>
                    <label class="btn btn-secondary">
                        <b-form-radio value="Invité annulé">Invité annulé</b-form-radio>
                    </label>
                </b-form-radio-group>
            </div>
            <span class="btn" @click="$emit('delete-me')">supprimer cet intervenant</span>
        </div>
        <b-alert v-else show variant="danger">
            <div v-for="error in errors">{{error}}</div>
        </b-alert>
    </div>


</template>

<script>

  import bdd from '../../api/bdd'
  import contact from './Contact'


  export default {

    name: 'Intervenant',

    components: {
      contact
    },

    props: ['intervenantId', 'index'],

    data() {
      return {
        intervenant: {
          type: '',
          statut: '',
          aInviter: '',
          envoiEmail: null
        },
        test: 'test',
        errors: [],
        newContact: false,
        contact: {},
        changePartage: false
      }
    },

    mounted() {
      bdd.getIntervenant(this.intervenantId)
        .then(intervenant => {
            this.intervenant = intervenant
            this.$watch(
              'intervenant', () => {
                this.updateIntervenant()
              },
              {deep: true}
            )
            console.log('intervenant récupéré :', this.intervenantId, 'contact :', this.intervenant.contact)
          }
        )
    },

    methods: {
      updateIntervenant: function () {
        if (this.intervenant.statut === 'Invité validé' && this.intervenant.aInviter === "true" && !this.changePartage) {
          this.intervenant.envoiEmail = true
        }
        if (this.intervenant.statut === 'Invité annulé' && !this.changePartage) {
          this.intervenant.envoiEmail = false
        }
        bdd.persistIntervenant(this.intervenantId, this.intervenant)
          .then(response => {
            console.log('update intervenant', this.intervenantId, response)
            console.log(this.intervenant.type)
            this.pushIntervenant()
            this.changePartage = false
          })
      },
      addContact: function () {
        bdd.addContact(this.intervenantId)
          .then(contactId => {
            this.newContact = true
            this.intervenant.contact = contactId
            console.log('ajout d\'un contact', contactId)
          })
      },
      updateContact: function (contact) {
        this.contact = contact
        this.pushIntervenant()
      },
      pushIntervenant: function () {
        this.$emit('update-intervenant', this.intervenant, this.intervenantId, this.contact)
      },
      lockChangePartage: function () {
        this.changePartage = true
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/EditSub/Intervenant.vue